import { api } from "./base.api.ts"

export const createPaymentSheet = async () => {
    const res = await api.post("payment-sheet");
    return res.data
}

export const addpaymentMethod = async (paymentData) => {
    const res = await api.post("add-payment-method", paymentData);
    return res.data
}

export const setDefaultPaymentMethod = async (paymentMethod) => {
    const res = await api.post("set-default-payment-method", paymentMethod);
    return res.data
}

export const addUserPaymentCard = async ({ PaymentMethodId }) => {
    const res = await api.post("add-user-payment-card", { PaymentMethodId });
    return res.data
}

export const getUserPaymentCard = async () => {
    const res = await api.get("get-user-payment-card");
    return res.data;
}


// Teacher payment methods
export const getTeacherPayoutMethods = async () => {
    const res = await api.get("get-teacher-payout-methods");
    return res.data
}

export const deleteTeacherPayoutMethods = async (stripeAccount) => {
    await api.delete("delete-payment-method/" + stripeAccount);
}


export const setDefaultPayoutMethod = async (paymentMethod) => {
    const res = await api.post("set-default-payout-method", paymentMethod);
    return res.data
}
